type BadgeVariant = "fail" | "warning" | "advisory" | "pass";

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
}

const LABELS: Record<BadgeVariant, string> = {
  fail: "Hard fail",
  warning: "Warning",
  advisory: "Advisory",
  pass: "Pass",
};

const ICONS: Record<BadgeVariant, string> = {
  fail: "✗",
  warning: "⚠",
  advisory: "ℹ",
  pass: "✓",
};

export function StatusBadge({ variant, label }: StatusBadgeProps) {
  return (
    <span className={`badge badge--${variant}`} role="status">
      <span aria-hidden="true">{ICONS[variant]}</span>
      {label ?? LABELS[variant]}
    </span>
  );
}
